import React from 'react';
import { CheckIcon } from 'lucide-react';
import { audienceItems, timeValueTasks } from '../data/finanza';
export function Audience() {
  return <section className="w-full bg-stone-50 px-8 py-24 sm:px-14 sm:py-32" data-id="element-19" data-mp="3p26z2jkodvud">
      <div className="mx-auto grid max-w-6xl gap-14 lg:grid-cols-12" data-id="element-20" data-mp="6vsp0vpj2619">
        <div className="lg:col-span-7" data-id="element-21" data-mp="1v4wu6pkbj5g">
          <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-[#1E2B58] sm:text-6xl" data-id="element-22" data-mp="1u39b2rd146u">
            Per chi è <em className="text-[#1F9D6B]" data-id="element-23" data-mp="gqsx5krrfm42">FINANZA PRONTA™</em>?
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-[#1E2B58]/75" data-id="element-24" data-mp="btawsirt6f7o">Il pacchetto è per te se:</p>
          <ul className="mt-8 grid gap-x-8 border-t border-[#1E2B58]/15 sm:grid-cols-2" data-id="element-25" data-mp="pkpiixd3ouif">
            {audienceItems.map(item => <li key={item} className="flex gap-3 border-b border-[#1E2B58]/10 py-4 leading-snug text-[#1E2B58]/80" data-id="element-26" data-mp="llqerg33v3sk">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-[#1F9D6B]" strokeWidth={2.5} aria-hidden="true" data-id="element-27" data-mp="ukbuz4l3u6q6" />
                {item}
              </li>)}
          </ul>
          <p className="mt-8 font-serif text-xl italic leading-snug text-[#1E2B58]/80" data-id="element-28" data-mp="16esw6viddm5c">
            Creato per maestre, maestri e docenti che vogliono meno tempo di preparazione e più
            tempo per i loro alunni.
          </p>
        </div>

        <aside className="self-start rounded-3xl bg-[#1E2B58] p-8 text-stone-50 sm:p-11 lg:col-span-5" data-id="element-29" data-mp="1kd94urzslmq4">
          <h3 className="font-serif text-3xl leading-tight sm:text-4xl" data-id="element-30" data-mp="1pcm1g4ggu85w">Quanto vale il tuo tempo?</h3>
          <p className="mt-4 leading-relaxed text-stone-50/75" data-id="element-31" data-mp="1ua5dcxpoy8uo">
            Pensa a quante ore dedichi ogni anno a preparare l'educazione finanziaria:
          </p>
          <ul className="mt-5 divide-y divide-white/10 border-y border-white/10" data-id="element-32" data-mp="240qmvg6wkxsd">
            {timeValueTasks.map(task => <li key={task} className="py-3 text-[15px] text-stone-50/85" data-id="element-33" data-mp="282llue1d2z2z">
                {task}
              </li>)}
          </ul>
          <p className="mt-6 leading-relaxed text-stone-50/75" data-id="element-34" data-mp="2d2gbke9ehimg">
            Ora immagina un pacchetto organizzato che ti aiuta in tutto questo – per tutto l'anno
            scolastico.
          </p>
          <p className="mt-4 font-serif text-xl italic leading-snug text-[#F2B134]" data-id="element-35" data-mp="8ylhak7lpzja">
            Non devi più ripartire da zero.
          </p>
        </aside>
      </div>
    </section>;
}